<div class="container">
  <input
    (ngModelChange)="onChangeSearchValue$.next($event)"
    [(ngModel)]="searchTerm" placeholder="Wyszukaj po nazwie..."
    style="width: 100%;"
    type="text"
    pInputText
  />

  <div class="container__list">
    <p-tree
      [value]="filteredTreeNodes()"
      [filter]="false"
      (selectionChange)="onSelectGroup($any($event))"
      selectionMode="single"
      class="unit-tree"
    ></p-tree>
  </div>

  <div class="container__modal-footer">
    <button pButton label="Anuluj" class="p-button-text" severity="danger" (click)="cancel()"></button>
    <button pButton label="Zatwierdź" class="p-button-primary" (click)="confirm()"></button>
  </div>
</div>
